<template>
  <div class="pb-2">
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == false">
      <b-card no-body>
        <b-card-header>
          <h4>ข้อมูลส่วนตัว</h4>
        </b-card-header>
        <b-card-body>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="ชื่อ :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="firstName" class="col-md-7"/>
                    <span v-if="this.valFirstname == false" class="pl-1" style="color:red">*กรุณาระบุ</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="นามสกุล :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="lastName" class="col-md-7"/>
                    <span v-if="this.valLastname == false" class="pl-1" style="color:red">*กรุณาระบุ</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="ชื่อเล่น :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="nickName" class="col-md-7"/>
                    <span v-if="this.valNickname == false" class="pl-1" style="color:red">*กรุณาระบุ</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="เพศ :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-radio-group
                      v-model="gender"
                      :options="optionsGender"
                      @change="test()"
                    >
                    </b-form-radio-group>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="Email :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="email" class="col-md-7"/>
                    <span v-if="this.valEmail == false" class="pl-1" style="color:red">*กรุณาระบุ</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="เบอร์โทรศัพท์ :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="phone" class="col-md-7"/>
                    <span v-if="this.valPhone == false" class="pl-1" style="color:red">*กรุณาระบุ</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="วันเกิด :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <flat-pickr v-model="birthDate" @click="test()" class="form-control col-md-5" :config="datePickerConfig"/>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="font-weight-slim"
                  label="ลิ้งค์ร้านค้าของท่าน :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="linkShop" class="col-md-5"/>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <b-button
                      @click="btnUpdateCustomerInfo()"
                      variant="primary"
                      :disabled="this.loadButton == false"
                    >
                      <b-spinner v-if="this.loadButton == false" small/>
                      บันทึกข้อมูล
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header>
          <h3>ข้อมูลเปิดไอดีเถาเปา</h3>
        </b-card-header>
        <b-card-body>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="ID Taobao :"
                  label-cols-md="3"
                >
                {{this.customerInfo.taobaoID}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="รหัสผ่าน Taobao :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.taobaoPass}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="รหัสจ่ายตัง :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.paymentPass}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="CODE :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.taobaoReceiveName}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Email ที่ใช้สมัคร :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.emailTaobao}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="เบอร์โทรที่ใช้สมัคร :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.phoneTaobao}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="คำถามลับ :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.securityQuestion}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="คำตอบลับ :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.securityAnswer}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="ID ยืนยันตน :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.taobaoIDregis}}
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header>
          <h3>Username/Password</h3>
        </b-card-header>
        <b-card-body>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Username  :"
                  label-cols-md="3"
                >
                  {{this.customerInfo.userName}}
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="รหัสผ่าน  :"
                  label-cols-md="3"
                >
                  <div class="d-flex align-items-center">
                    <span class="pr-1">{{this.credentialCount}}</span>
                    <span>
                      <b-link :to="{ name: 'me-update-password', params: { user: this.customerInfo.userName }}">
                        แก้ไขรหัสผ่าน
                      </b-link> /
                      <b-link :to="{ name: 'forgot-password'}" target="_blank">ลืมรหัสผ่าน</b-link>
                    </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>

      <!-- <b-card no-body>
        <b-card-header>
          <h3>อัปโหลดหนังสือรับรอง / ภพ.20</h3>
        </b-card-header>
        <b-card-body>
          <div class="text-right pb-1">
            <b-button variant="primary" v-b-modal.file-cert>
              อัปโหลดไฟล์
            </b-button>
          </div>
          <b-table
            responsive
            :items="fileList"
            :fields="fileFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(rowID)="data">
              <feather-icon
                :id="`edit-${data.value}`"
                icon="EditIcon"
                class="cursor-pointer text-warning"
                size="20"
                @click="openEdit(data.item)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`edit-${data.value}`"
                :delay="{show: '1500'}"
              />
            </template>
            <template #cell(fileCompanyCert)="data">
              <b-link :href="data.value" target="_blank">
                คลิก
              </b-link>
            </template>
            <template #cell(fileVatCert)="data">
              <b-link :href="data.value" target="_blank">
                คลิก
              </b-link>
            </template>
            <template #cell(address)="data">
              <div>
                {{data.value + ' ' + data.item.subDistrict + ' ' + data.item.district + ' ' + data.item.province + ' ' + data.item.postcode}}
              </div>
            </template>
          </b-table>
        </b-card-body>
      </b-card> -->

      <!-- company -->
      <b-card no-body>
        <b-card-header>
          <h3>รายการบริษัท</h3>
        </b-card-header>
        <b-card-body>
          <div class="text-right pb-1">
            <b-button variant="primary" :to="{ name: 'company-information'}">
              เพิ่มบริษัท
            </b-button>
          </div>
          <b-table
            responsive
            :items="companyList"
            :fields="companyFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(id)="data">
              <feather-icon
                :id="`edit-${data.value}`"
                icon="EditIcon"
                class="cursor-pointer text-warning"
                size="20"
                @click="toCompanyInfoPage(data.value)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`edit-${data.value}`"
                :delay="{show: '1500'}"
              />
              <feather-icon
                :id="`del-${data.value}`"
                icon="TrashIcon"
                class="cursor-pointer text-danger ml-1"
                size="20"
                @click="deleteCompany(data.value)"
              />
              <b-tooltip
                title="ลบ"
                :target="`del-${data.value}`"
                :delay="{show: '1500'}"
              />
            </template>
          </b-table>
        </b-card-body>
      </b-card>

    </div>

    <!-- <b-modal
      ref="file-cert"
      id="file-cert"
      @hidden="closeAct"
      title-class="h3"
      title="อัปโหลดไฟล์"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
            class="font-weight-slim"
            label="บริษัท :"
          >
            <div class="align-items-center">
              <b-form-input v-model="companyName"/>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            class="font-weight-slim"
            label="ที่อยู่ :"
          >
            <div class="align-items-center">
              <b-form-Textarea v-model="companyAddress"/>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            class="font-weight-slim"
            label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :"
          >
            <div class="d-flex align-items-center">
              <v-select
                class="px-0 col-12"
                v-model="postcode"
                :options="postcodeMapping"
                label="list"
              ></v-select>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            class="font-weight-slim"
            label="หนังสือรับรอง :"
          >
            <div class="align-items-center">
              <b-form-file
                v-model="compayCertFile"
                placeholder="Choose a file"
                drop-placeholder="Drop file here..."
              />
            </div>
            <small v-if="this.rowID != null">ไฟล์เดิม <b-link :href="this.currFile_1" target="_blank">คลิก</b-link></small>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            class="font-weight-slim"
            label="ภพ.20 :"
          >
            <div class="align-items-center">
              <b-form-file
                v-model="vatCertFile"
                placeholder="Choose a file"
                drop-placeholder="Drop file here..."
              />
            </div>
            <small v-if="this.rowID != null">ไฟล์เดิม <b-link :href="this.currFile_2" target="_blank">คลิก</b-link></small>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="text-right">
        <b-button variant="primary" @click="actionFileCert" :disabled="this.loadButton == false">
          <b-spinner v-if="this.loadButton == false" small/>
          บันทึก
        </b-button>
        <b-button class="ml-1" variant="outline-danger" @click="closeAct">
          ยกเลิก
        </b-button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import {
  BFormFile, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  BImg, BTable, VBToggle, BTooltip
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token, specify_header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  name: 'Taobao2youInformation',

  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal
  },

  components: {
    BCard, BCardHeader, BCardBody, BForm, BFormGroup, BRow, BCol, BLink, BButton, BFormInput,
    BFormRadioGroup, BFormRadio, BSpinner, ToastificationContent, BTable, vSelect, BModal,
    BFormTextarea, BFormFile, BTooltip,

    flatPickr,
   },

  data() {
    return {
      loadpage: true,
      //ข้อมูลส่วนตัว
      userData: JSON.parse(localStorage.getItem('userData')),
      customerInfo: [],
      firstName: '',
      lastName: '',
      nickName: '',
      gender: '',
      email: '',
      phone: '',
      birthDate: '',
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      linkShop: '',
      optionsGender: [
        { text: 'ชาย', value: 'ชาย' },
        { text: 'หญิง', value: 'หญิง' },
      ],

      valFirstname: true,
      valLastname: true,
      valNickname: true,
      valEmail: true,
      valPhone: true,

      credentialCount: '',

      //ข้อมูลไอดีเถาเปา
      idTaobao: '',
      passTaobao: '',
      passPayment: '',
      code: '',
      emailRegister: '',
      phoneRegister: '',
      secretQuestion: '',
      secretAnswer: '',
      verifyId: '',

      //file cert
      rowID: null,
      companyName: '',
      compayCertFile: null,
      vatCertFile: null,
      companyAddress: '',
      postcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 },
      postcodeMapping: [],
      fileList:[],
      fileFields: [
        { key: 'rowID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'companyName', label:'บริษัท', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fileCompanyCert', label: 'หนังสือรับรอง', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fileVatCert', label:'ภพ.20', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'address', label: 'ที่อยู่', thClass: 'text-center' },
      ],
      currFile_1: '',
      currFile_2: '',

      loadButton: true,
      loadBtnFile: true,

      //company
      companyList:[],
      companyFields: [
        { key: 'id', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'companyName', label:'บริษัท', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fullAddress', label: 'ที่อยู่', thClass: 'text-center' },
        { key: 'taxID', label:'เลขผู้เสียภาษี', thClass: 'text-center', tdClass: 'text-center' },
      ],
    };
  },

  async created() {
    await this.getCustomer()
    // await this.getFileCert()
    await this.getCredentialCount()
    await this.getCompany()
    this.getPostcode()
    this.loadpage = false
  },

  methods: {
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },
    async getCustomer() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-info',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: specify_header_token }
      );
      this.customerInfo = await response.data
      this.firstName = response.data.firstName
      this.lastName = response.data.lastName
      this.nickName = response.data.nickName
      this.gender = response.data.sex
      this.email = response.data.email
      this.phone = response.data.phoneNumber
      this.birthDate = response.data.birthDate
      this.linkShop = response.data.shopWebsite

    },
    async getCredentialCount() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/credential-number-characters',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          // localStorage.getItem('auth_token')
        },
        { headers: specify_header_token }
      );

      var count = ''
      for (let i = 0; i < response.data; i++) {
        count = count + '*'
      }
      this.credentialCount = count
    },
    async btnUpdateCustomerInfo() {
      this.loadButton = false
      if ( this.firstName == '' ) {
        this.valFirstname = false
      } if ( this.lastName == '' ) {
        this.valLastname = false
      } if ( this.nickName == '' ) {
        this.valNickname = false
      } if ( this.email == '' ) {
        this.valEmail = false
      } if ( this.phone == '' ) {
        this.valPhone = false
      } else if ( this.firstName != '' && this.lastName != '' && this.nickName != '' && this.email != '' && this.phone != '' ) {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/update-customer-info',
          {
            "loginToken": this.userData.data.customerInfo.loginToken,
            "firstName": this.firstName,
            "lastname": this.lastName,
            "nickName": this.nickName,
            "sex": this.gender,
            "email": this.email,
            "phoneNumber": this.phone,
            "birthDate": this.birthDate,
            "shopWebsite": this.linkShop
          },
          { headers: specify_header_token }
        );
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แก้ไขข้อมูลส่วนตัวเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
      }
      this.loadButton = true
    },

    //file cert
    // async getFileCert() {
    //   let response = await axios.post(
    //     taobaoService_dotnet + 'app/FileCertificate/get-file-cert',
    //     {
    //       "customerID": JSON.parse(localStorage.getItem('cusId')),
    //     },
    //     { headers: header_token }
    //   );
    //   this.fileList = response.data
    // },
    // async actionFileCert() {
    //   if (this.companyName == '' || this.companyAddress == '' || this.postcode == null || this.postcode.rowID == 0) {
    //     this.$swal({
    //       position: 'top',
    //       title: 'กรอกข้อมูลไม่ครบ !',
    //       text: 'กรุณากรอกข้อมูลให้ครบทุกช่อง !',
    //       icon: 'warning',
    //       showCancelButton: false,
    //       confirmButtonText: 'เข้าใจแล้ว',
    //       customClass: {
    //         confirmButton: 'btn btn-primary',
    //         text: 'text-danger'
    //       },
    //       buttonsStyling: false,
    //     })
    //   } else if ((this.compayCertFile == null || this.vatCertFile == null) && this.rowID == null) {
    //     this.$swal({
    //       position: 'top',
    //       title: 'กรอกข้อมูลไม่ครบ !',
    //       text: 'กรุณากรอกข้อมูลให้ครบทุกช่อง !',
    //       icon: 'warning',
    //       showCancelButton: false,
    //       confirmButtonText: 'เข้าใจแล้ว',
    //       customClass: {
    //         confirmButton: 'btn btn-primary',
    //         text: 'text-danger'
    //       },
    //       buttonsStyling: false,
    //     })
    //   } else {
    //     this.loadBtnFile = false
    //     var file_1 = ''
    //     var file_2 = ''
    //     if (this.compayCertFile != null) {
    //       file_1 = await this.addPhoto(this.compayCertFile)
    //     }
    //     if (this.vatCertFile != null) {
    //       file_2 = await this.addPhoto(this.vatCertFile)
    //     }
    //     let response = await axios.post(
    //       taobaoService_dotnet + 'app/FileCertificate/action-file-cert',
    //       {
    //         "rowID": this.rowID,
    //         "customerID": JSON.parse(localStorage.getItem('cusId')),
    //         "fileCompanyCert": file_1 != '' ? file_1 : this.currFile_1,
    //         "fileVatCert": file_2 != '' ? file_2 : this.currFile_2,
    //         "companyName": this.companyName,
    //         "address": this.companyAddress,
    //         "postcodeMappingID": this.postcode.rowID
    //       },
    //       { headers: header_token }
    //     );
    //     if (response.data == 'success') {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: 'สำเร็จ',
    //           icon: 'CheckIcon',
    //           text: 'บันทึกข้อมูลเรียบร้อย',
    //           variant: 'success',
    //         },
    //       },
    //       {
    //         position: 'top-center',
    //       })
    //       this.getFileCert()
    //       this.closeAct()
    //     }
    //     this.loadBtnFile = true
    //   }
    // },
    // async openEdit(item) {
    //   this.rowID = item.rowID
    //   this.companyName = item.companyName
    //   this.companyAddress = item.address
    //   this.postcode = this.postcodeMapping.filter(x => x.rowID == item.postcodeMappingID)[0]
    //   this.currFile_1 = item.fileCompanyCert
    //   this.currFile_2 = item.fileVatCert
    //   this.$refs['file-cert'].show()
    // },
    // closeAct() {
    //   this.$refs['file-cert'].hide()
    //   this.rowID = null
    //   this.companyName = ''
    //   this.companyAddress = ''
    //   this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 }
    //   this.compayCertFile = null
    //   this.vatCertFile = null
    //   this.currFile_1 = ''
    //   this.currFile_2 = ''
    // },

    //company
    async getCompany() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Company/get-company-info',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      this.companyList = response.data
    },
    async toCompanyInfoPage(id) {
      this.$router.push({path: '/company/information?companyID=' + id})
    },
    async deleteCompany(id) {
      this.$swal({
        title: 'ลบข้อมูลบริษัท ?',
        text: 'คุณต้องการลบข้อมูลบริษัทหรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Company/delete-company-info',
            {
              "id": id,
            },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบข้อมูลบริษัทเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            this.getCompany()
          }
        }
      })
    },

    async addPhoto(file) {
      var fileLink = null
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', file);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=2',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) { fileLink = response.data })
      .catch(function (error) { console.log(error); });
      return fileLink[0]
    }
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>